// Статусы для функций пользователя
const status = {
	ignore: 0,
	action: 1,
}

export {
	status
}
